import { createTheme } from '@material-ui/core/styles';


const theme = createTheme({
    typography: {
      fontFamily: ['proxima-nova', 'sans-serif'].join(','),
      color:"#1d1d1b"
     }
   })

export default theme;